import React from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../../components";
import OpenInvoices from "../../Vendor/AddVendor/Invoicesandpayments/OpenInvoices";
import DueInvoices from "../../Vendor/AddVendor/Invoicesandpayments/DueInvoices";
import PaidInvoices from "../../Vendor/AddVendor/Invoicesandpayments/PaidInvoices";
import AllInvoices from "../../Vendor/AddVendor/Invoicesandpayments/AllInvoices";
import Payments from "../../Vendor/AddVendor/Invoicesandpayments/Payments";

const Invoicesandpayments = ({ vendorId }) => {
  const InvoicesandpaymentsMenus2 = [
    {
      title: "Open Invoices",
      page: <OpenInvoices vendorId={vendorId} />,
      type: "main",
    },
    {
      title: "Due Invoices",
      page: <DueInvoices vendorId={vendorId} />,
      type: "main",
    },
    {
      title: "Paid Invoices",
      page: <PaidInvoices vendorId={vendorId} />,
      type: "main",
    },
    {
      title: "All Invoices",
      page: <AllInvoices vendorId={vendorId} />,
      type: "main",
    },
    {
      title: "Payments",
      page: <Payments vendorId={vendorId} />,
      type: "main",
    },
  ];
  return (
    <div>
      <PageHeader
        Section={
          <div className="flex mb-8 mt-4">
            <PageTitle
              title={"Invoices and payments"}
              icon={"badge"}
              tag="h5"
            />
          </div>
        }
      />
      <NewTab
        tabs={InvoicesandpaymentsMenus2}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="invoices-and-payments"
      />
    </div>
  );
};

export default Invoicesandpayments;
